export default __webpack_public_path__ + "static/media/wildlife01.b21a7fb9.png";